import SurveySettings from '../models/interfaces/SurveySettings';
import SoluCXService from './SolucxService';
import UrlParsedInfo from './UrlParsedInfo';

/**
 * Classe de serviços para interagir com a API SoluCX
 */
export default class SoluCXServiceOld extends SoluCXService {
  public urlInfo: UrlParsedInfo = null;

  public constructor(baseURL: string, apiKey: string) {
    super({baseURL, apiKey});
  }

  // -------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

  /**
   * cria uma nova transação e pesquisa
   */
  public async getNewSurveyConfiguration(
    employeeId?: string,
    storeId?: string,
    avalRef?: string,
  ): Promise<SurveySettings> {
    const params = {
      // name: 'cliente',
      // store_id: storeId,
      // employee_id: employeeId,
      // // cpf: 0,
      source: 'tablet',
      template: false,
      // rating: -1,
      // amount: 0,
      aval_ref: avalRef,
    };

    try {
      const r = await this.axios.get<SurveySettings>('rating/form/', { params });
      r.data.attemptId = r.data.attemptId.toString();
      r.data.transactionId = r.data.transactionId.toString();
      return r.data;
    } catch (error) {
      return error.response.data;
    }
  }

  /**
   * Adquire dados de um survey Tablet existente
   */
  public async getSurveyConfigurationTablet(
    transactionId: string,
    attemptId: string,
    storeId: string,
    employeeId: string,
    journeyId: string,
    journey: string,
  ): Promise<SurveySettings> {
    const params = {
      transactionId: transactionId,
      idAttempt: attemptId,
      name: 'cliente',
      store_id: storeId,
      employee_id: employeeId,
      cpf: 0,
      source: 'tablet',
      template: false,
      rating: -1,
      amount: 0,
      journey_id: journeyId,
      journey: journey,
    };

    try {
      const r = await this.axios.get<SurveySettings>('rating/form/', {
        params,
      });
      return r.data;
    } catch (error) {
      if (error.response.data && error.response.data.errors) throw error.response.data;
      else throw error;
    }
  }

  /**
   * Adquire dados de um survey Totem existente se existir store
   */
  public async getSurveyConfigurationByStore(
    transactionId: string,
    attemptId: string,
    storeId: string,
  ): Promise<SurveySettings> {
    const params = {
      transactionId: transactionId,
      attemptId: attemptId,
      name: 'cliente',
      store_id: storeId,
      cpf: 0,
      source: 'tablet',
      template: false,
      rating: -1,
      amount: 0,
    };

    try {
      const r = await this.axios.get<SurveySettings>('rating/form/', {
        params,
      });
      return r.data;
    } catch (error) {
      if (error.response.data && error.response.data.errors) throw error.response.data;
      else throw error;
    }
  }

  /**
   * Adquire dados de um survey Totem existente se existir store & employee
   * @param storeId Id da unidade
   * @param employeeId Id do funcionário
   */
  public async getSurveyConfigurationByEmployee(
    transactionId: string,
    attemptId: string,
    storeId: string,
    employeeId: string,
    journeyId: string,
    journey: string,
  ): Promise<SurveySettings> {
    const params = {
      transactionId: transactionId,
      attemptId: attemptId,
      name: 'cliente',
      store_id: storeId,
      employee_id: employeeId,
      cpf: 0,
      source: 'tablet',
      template: false,
      rating: -1,
      amount: 0,
      journey_id: journeyId,
      journey: journey,
    };

    try {
      const r = await this.axios.get<SurveySettings>('rating/form/', {
        params,
      });

      // check consistense
      if (!r.data.parameters) throw new Error('invalid input');

      return r.data;
    } catch (error) {
      if (error.response.data && error.response.data.errors) throw error.response.data;
      else throw error;
    }
  }

  /**
   * Digital
   * Adquire dados de uma transação existente
   * @param transactionId Id da transação
   * @param attemptId Id da attemptId de avaliação
   */
  public async getSurveyConfigurationByAttempt(
    transactionId: string,
    attemptId: string,
    journeyId: string,
    journey: string,
    score?: string,
  ): Promise<SurveySettings> {
    const params = {
      transactionId: transactionId,
      attemptId: attemptId,
      template: false,
      journey_id: journeyId,
      journey: journey,
      score: score,
    };
    try {
      const r = await this.axios.get<SurveySettings>('rating/form/', {
        params,
      });

      // check consistense
      if (!r.data.parameters) throw new Error('invalid input');

      // return data
      return r.data;
    } catch (error) {
      if (error.response.data && error.response.data.errors) throw error.response.data;
      else throw error;
    }
  }

  /**
   * Adquire dados de uma transação existente
   * @param transactionId Id da transação
   * @param attemptId Id da attemptId de avaliação
   */
  public async getSurveyConfigurationByTransaction(urlData: UrlParsedInfo): Promise<SurveySettings> {
    const params = { ...urlData };

    // clean
    params.hash = undefined;
    params.apitoken = undefined;
    params.transactionId = undefined;
    params.attemptId = undefined;
    params.sandbox = undefined;
    params.test = undefined;
    // params.template = this.translateTemplate(params.template);

    try {
      const r = await this.axios.get<SurveySettings>('rating/form/', {
        params,
      });
      return r.data;
    } catch (error) {
      if (error.response.data && error.response.data.errors) throw error.response.data;
      else throw error;
    }
  }
}
